import API from 'utils/api';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/motocicletas/';

const files = [
  'comprobante_de_domicilio',
  'factura_del_vehiculo',
  'pedimento_del_vehiculo',
];

const headers = { 'Content-Type': 'multipart/form-data' };

const formatFks = (motocicleta) => ({
  ...motocicleta,
  marca: motocicleta.marca?.id || motocicleta.marca,
  propietario: motocicleta.propietario?.id || motocicleta.propietario,
  contribuyente_propietario: motocicleta.contribuyente_propietario?.id
    || motocicleta.contribuyente_propietario,
  color_del_vehiculo: motocicleta.color_del_vehiculo?.id || motocicleta.color_del_vehiculo,
});

/**
 * GET Motocicletas
 * @param {object} params
 * @returns {Promise<object>}
 */
export const getMotocicletas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return { ...response.data, results: formatReceived(response.data.results.map(formatFks)) };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Motocicleta
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getMotocicleta = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(formatFks(response.data));
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Motocicleta
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postMotocicleta = async (values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(baseURI, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(formatFks(response.data));
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Motociclet
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMotocicleta = async (id, values, clean = true) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean,
    });
    const response = await API.patch(`${baseURI}${id}`, formattedValues, config);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(formatFks(response.data));
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Motocicleta
 * @param {number} id
 * @param {number} idVehiculo
 * @returns {Promise<object|boolean>}
 */
export const deleteMotocicleta = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Para obtener los cargos de un vehiculo
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getMotocicletaCaja = async (params = null) => {
  try {
    const response = await API.get('recaudacion/motocicletas-caja', { params });
    return {
      ...formatReceived(response.data),
      results: formatReceived(response.data.results.map(formatFks)),
    };
  } catch (err) {
    onError(err);
    return [];
  }
};
